import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import sharedStyles from "../../landing-feature-store-hub.module.css";
import { Heading } from "@cinch-labs/design-system";
export const StoreHubIntro = ({ title , body  })=>/*#__PURE__*/ _jsxs("section", {
        children: [
            /*#__PURE__*/ _jsx(Heading, {
                element: "h2",
                className: sharedStyles.title,
                children: title
            }),
            /*#__PURE__*/ _jsx("div", {
                children: body
            })
        ]
    });
